// Sample landing content. Replace with admin-published values.
// These figures are layout examples, not an offer or a return guarantee.

export const site = {
  name: "Finitygrowth",
  announcement: {
    text: "Sample notice: package figures on this page are layout examples until admin publishing is connected.",
    startLabel: "21 Oct 2026",
    endLabel: "31 Dec 2026",
  },
  support: {
    hours: "Monday–Friday, 10:00–18:00",
    hoursNote: "Sample hours for this layout. Replace with the published support schedule.",
  },
  legal: {
    version: "1.0",
    effective: "21 October 2026",
  },
};

export function brandName(value) {
  const text = String(value || "").trim();
  if (!text || /stravex/i.test(text)) return site.name;
  return text;
}

export const exploreLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Travel Reward", href: "#trip" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Referrals", href: "#referrals" },
  { label: "Income", href: "#income" },
  { label: "FAQs", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export const accountLinks = [
  { label: "Login", href: "#/login" },
  { label: "Sign Up", href: "#/signup" },
];

export const legalLinks = [
  { label: "Terms", href: "#legal" },
  { label: "Privacy", href: "#legal" },
  { label: "Risk Disclosure", href: "#legal" },
  { label: "Refund Policy", href: "#legal" },
];

export const steps = [
  { title: "Register", text: "Create an account and complete the checks the admin has turned on." },
  { title: "Fund Account", text: "Add funds with an enabled method. A screenshot alone does not credit the wallet." },
  { title: "Activate Package", text: "Buy a published package with available balance. The quote is confirmed again on submit." },
  { title: "Track Income", text: "Follow daily, direct and level entries. Only posted income can be used." },
  { title: "Request Withdrawal", text: "Submit in the published window. The quote shows gross, fees and net before you confirm." },
];

export const balanceNotes = [
  "Available balance is money you can use. A scheduled entitlement stays on the plan until it is posted.",
  "A package completes when its published schedule ends. History is kept.",
  "Referral income depends on qualified directs and unlocked levels. Your direct count and your team depth are different.",
  "Re-top-up, when required, is a new purchase linked to the earlier plan.",
];

export const packages = [
  {
    id: "sample-fixed",
    order: 1,
    name: "Sample Fixed Plan",
    price: "100",
    currency: "USDT",
    payoutMethod: "Fixed daily payout",
    dailyAmount: "1 USDT",
    formula: "",
    duration: "100 days",
    totalScheduled: "100 USDT",
    // Numeric copies for the illustrative charts. Leave null when no fixed schedule is published.
    dailyValue: 1,
    durationDays: 100,
    principal: "Principal is included in the scheduled payouts. Show these amounts as payouts, not as pure profit.",
    limits: "Sample limit: 1 active plan of this version per member.",
  },
  {
    id: "sample-variable",
    order: 2,
    name: "Sample Variable Plan",
    price: "500",
    currency: "USDT",
    payoutMethod: "Variable daily formula",
    dailyAmount: "",
    formula: "Daily amount follows the formula published for this package version.",
    duration: "Set by the published version",
    totalScheduled: "",
    dailyValue: null,
    durationDays: null,
    principal: "Principal treatment follows the rule published for this version.",
    limits: "Sample limit: the amount must stay inside the published minimum and maximum.",
  },
];

export const incomeRules = [
  {
    title: "Own daily payouts",
    text: "Each active package posts its own schedule. Posted payouts can be used. Pending, held, skipped and reversed entries stay labeled as such.",
  },
  {
    title: "Direct referral",
    text: "A commission is recorded when a direct referral’s purchase qualifies under the current rule. The source purchase stays traceable.",
  },
  {
    title: "Level income",
    text: "Qualified direct referrals unlock earning depth. The rate, base and release schedule come from the active level rule.",
  },
  {
    title: "Rewards",
    text: "Rewards follow their own eligibility rule. A trip or other benefit is not wallet cash unless that reward says so.",
  },
];

export const referral = {
  calculationBase: "Qualifying purchase amount",
  schedule: "Released on the published commission schedule",
  levels: [
    { level: 1, rate: "5%", directs: "1 qualified direct" },
    { level: 2, rate: "3%", directs: "2 qualified directs" },
    { level: 3, rate: "2%", directs: "3 qualified directs" },
    { level: 4, rate: "1%", directs: "4 qualified directs" },
    { level: 5, rate: "1%", directs: "5 qualified directs" },
  ],
};

export const reward = {
  name: "Sample travel reward",
  eligibility: "Opens after the published purchase and qualified-direct conditions are met.",
  benefits: "An approved claim can book the published trip. This does not add cash to the wallet.",
  conditions: "Preferred dates and traveler details are collected only if a claim is part of the approved process.",
};

// Investment milestone reward shown on the landing page. Keep in sync with the admin's reward rules.
export const tripReward = {
  threshold: 400000,
  currency: "USDT",
  title: "International trip",
  steps: [
    { title: "Invest", text: "Reach a total package investment of 400,000 USDT or more." },
    { title: "Qualify", text: "Your eligibility is checked against the published reward rules and confirmed by the team." },
    { title: "Travel", text: "Claim your trip from the Rewards page. Dates and traveller details are arranged with you." },
  ],
  terms:
    "Terms apply. The trip is a benefit, not wallet cash, and cannot be exchanged for money. Destination, dates and what is included follow the published reward rules.",
};

export const withdrawal = {
  schedule: "Sample mode: requests can be submitted during the published window and are processed on the published day.",
  minimum: "20 USDT",
  fee: "The admin fee and any network fee are shown before confirmation.",
  methods: "Enabled payout methods only. This sample lists USDT on the published network.",
};

export const faqs = [
  {
    q: "Where do the package rules come from?",
    a: "From the configuration the admin has published. This site does not keep a second, private set of rates.",
  },
  {
    q: "Is a scheduled payout the same as available balance?",
    a: "No. Available balance can be transferred or withdrawn when the rules allow it. A scheduled amount stays on the plan until it is posted.",
  },
  {
    q: "Does a transfer activate a package?",
    a: "No. A transfer only moves available funds to another member. It does not buy a package or qualify a referral.",
  },
  {
    q: "When can a withdrawal be requested?",
    a: "Inside the published window, within the published minimum and maximum. A daily payout credit is not an on-chain withdrawal.",
  },
];
